<template>
  <div id="widget-builder">
    <p class="widget-instructions">
      {{ $t("widget_details.step_2") }}
    </p>
    <p>
      {{ $t("widget_details.builder_link1") }}
      <a @click="scrollMeTo('custom_attributes')">{{
        $t("widget_details.builder_link2")
      }}</a
      >{{ $t("widget_details.builder_link3") }}
    </p>
    <br />
    <div class="columns">
      <div class="column is-12">
        <div class="card widget-options">
          <div class="columns ">
            <div class="column is-6">
              <!-- html code box -->
              <div class="card-content">
                <fieldset class="subtitle form">
                  <b-tooltip
                    multilined
                    size="is-large"
                    position="is-right"
                    :label="$t('form_fields.html_tooltip')"
                  >
                    <legend>
                      {{ $t("form_fields.html_title") }}
                    </legend>
                  </b-tooltip>
                </fieldset>
                <div class="is-block widget-code">
                  <div class="html-code" ref="text">
                    &lt;{{ widget.tag }}
                    <br />
                    <div
                      v-if="
                        widget.id == '1' && widgetForm.provinceSelection != null
                      "
                    >
                      &nbsp;&nbsp;&nbsp;&nbsp;province="{{
                        widgetForm.provinceSelection
                      }}"
                      <br />
                    </div>
                    <div v-if="widgetForm.multipleSelection != null">
                      &nbsp;&nbsp;&nbsp;&nbsp;multiple="{{
                        widgetForm.multipleSelection
                      }}"
                    </div>
                    <div v-if="widgetForm.selectedLanguage != null">
                      &nbsp;&nbsp;&nbsp;&nbsp;lang="{{
                        widgetForm.selectedLanguage
                      }}"
                    </div>
                    <div v-if="widgetForm.selectedLanguage === null">
                      &nbsp;&nbsp;&nbsp;&nbsp;lang="{{ langChange }}"
                    </div>
                    <div v-if="widgetForm.showLabel != null">
                      &nbsp;&nbsp;&nbsp;&nbsp;show-label="{{
                        widgetForm.showLabel
                      }}"
                    </div>
                    <div v-if="widgetForm.label != ''">
                      &nbsp;&nbsp;&nbsp;&nbsp;label="{{ widgetForm.label }}"
                    </div>
                    <div v-if="widgetForm.placeholderDisplay != null">
                      <div v-if="widgetForm.placeholderDisplay == true">
                        &nbsp;&nbsp;&nbsp;&nbsp;placeholder-text="{{
                          widgetForm.placeholderLabel
                        }}"
                      </div>
                      <div v-if="widgetForm.placeholderDisplay == false">
                        &nbsp;&nbsp;&nbsp;&nbsp;placeholder-text=""
                      </div>
                    </div>
                    <div v-if="widgetForm.showCode != null">
                      &nbsp;&nbsp;&nbsp;&nbsp;show-code="{{
                        widgetForm.showCode
                      }}"
                    </div>
                    <div v-if="widgetForm.selectedVisibility != null">
                      &nbsp;&nbsp;&nbsp;&nbsp;visibility="{{
                        widgetForm.selectedVisibility
                      }}"
                    </div>
                    <div v-if="widgetForm.inputCode != false">
                      &nbsp;&nbsp;&nbsp;&nbsp;input-code="{{
                        widgetForm.inputCode
                      }}"
                    </div>
                    <div v-if="widgetForm.callback != ''">
                      &nbsp;&nbsp;&nbsp;&nbsp;@change="{{
                        widgetForm.callback
                      }}"
                    </div>
                    &gt;&lt;/{{ widget.tag }}&gt;
                  </div>
                  <ButtonCopy class="is-small is-pulled-right"></ButtonCopy>
                </div>
              </div>
              <div class="card-content">
                <!-- live example box -->
                <fieldset class="subtitle form">
                  <b-tooltip
                    multilined
                    size="is-large"
                    position="is-right"
                    :label="$t('form_fields.example_tooltip')"
                  >
                    <legend>
                      {{ $t("form_fields.example_title") }}
                    </legend>
                  </b-tooltip>
                </fieldset>
                <div class="card-content live-example">
                  <component
                    :is="widget.tag"
                    :province="provinceChange"
                    :multiple="multipleChange"
                    :lang="langChange"
                    :show-label="showlabelChange"
                    :show-code="showcodeChange"
                    :label="labelChange"
                    :placeholder-text="placeholderChange"
                    :visibility="visibilityChange"
                    :input-code="inputChange"
                    @change="changeCallback"
                  >
                  </component>
                </div>
              </div>
              <div class="card-content">
                <!-- live example results box -->
                <fieldset class="subtitle form">
                  <b-tooltip
                    multilined
                    size="is-large"
                    position="is-right"
                    :label="$t('form_fields.results_tooltip')"
                  >
                    <legend>
                      {{ $t("form_fields.results_title") }}
                    </legend>
                  </b-tooltip>
                </fieldset>
                <pre class="live-example-results">{{ results }}</pre>
              </div>
            </div>
            <!-- widget options form box -->
            <div class="column is-6 triangle-left column-dark">
              <div class="card-content">
                <fieldset class="subtitle form">
                  <b-tooltip
                    multilined
                    type="is-light"
                    size="is-large"
                    position="is-right"
                    :label="$t('form_fields.options_tooltip')"
                  >
                    <legend>
                      {{ $t("form_fields.component_options") }}
                    </legend>
                  </b-tooltip>
                </fieldset>
                <!-- form start -->
                <form id="widget-form" class="widget-form">
                  <!-- province/municipalities select -->
                  <b-field
                    v-if="widget.id == '1'"
                    horizontal
                    class="my-custom-class"
                    :label="$t('form_fields.province_label')"
                    label-for="province-select"
                  >
                    <b-select
                      id="province-select"
                      expanded
                      v-model="widgetForm.provinceSelection"
                      :placeholder="$t('form_options.placeholder_province')"
                    >
                      <option
                        v-for="option of $t('form_options.provinceOptions')"
                        :value="option.value"
                        :key="option.id"
                      >
                        {{ option.text }}
                      </option>
                    </b-select>
                  </b-field>
                  <!-- multiple select -->
                  <b-field
                    horizontal
                    class="my-custom-class"
                    :label="$t('form_fields.selection_label')"
                    label-for="multiple-select"
                  >
                    <b-select
                      id="multiple-select"
                      expanded
                      v-model="widgetForm.multipleSelection"
                      :placeholder="$t('form_options.placeholder_multiple')"
                    >
                      <option
                        v-for="option of $t('form_options.selectionOptions')"
                        :value="option.value"
                        :key="option.id"
                      >
                        {{ option.text }}
                      </option>
                    </b-select>
                  </b-field>
                  <!-- language select -->
                  <b-field
                    horizontal
                    class="my-custom-class"
                    :label="$t('form_fields.language_label')"
                    label-for="language-select"
                  >
                    <b-select
                      id="language-select"
                      expanded
                      v-model="widgetForm.selectedLanguage"
                      :placeholder="$t('form_options.placeholder_lang')"
                    >
                      <option
                        v-for="option of $t('form_options.languageOptions')"
                        :value="option.value"
                        :key="option.id"
                      >
                        {{ option.text }}
                      </option>
                    </b-select>
                  </b-field>
                  <!-- show label select -->
                  <b-field
                    horizontal
                    class="my-custom-class"
                    :label="$t('form_fields.display_label')"
                    label-for="show-label-select"
                  >
                    <b-select
                      id="show-label-select"
                      expanded
                      v-model="widgetForm.showLabel"
                      :placeholder="$t('form_options.placeholder_show_label')"
                    >
                      <option
                        v-for="option of $t('form_options.labelOptions')"
                        :value="option.value"
                        :key="option.id"
                      >
                        {{ option.text }}
                      </option>
                    </b-select>
                  </b-field>
                  <!-- custom label input -->
                  <b-field
                    horizontal
                    class="my-custom-class"
                    :label="$t('form_fields.field_label')"
                    label-for="field-label"
                  >
                    <b-input
                      id="field-label"
                      v-model="widgetForm.label"
                      :placeholder="$t('form_fields.placeholder_field_label')"
                    ></b-input>
                  </b-field>
                  <!-- show placeholder select -->
                  <b-field
                    horizontal
                    class="my-custom-class"
                    :label="$t('form_fields.placeholder_display_label')"
                    label-for="show-placeholder-select"
                  >
                    <b-select
                      id="show-placeholder-select"
                      expanded
                      v-model="widgetForm.placeholderDisplay"
                      :placeholder="
                        $t('form_options.placeholder_show_placeholder')
                      "
                    >
                      <option
                        v-for="option of $t('form_options.placeholderOptions')"
                        :value="option.value"
                        :key="option.id"
                      >
                        {{ option.text }}
                      </option>
                    </b-select>
                  </b-field>
                  <!-- custom placeholder input -->
                  <transition name="slide">
                    <b-field
                      v-if="widgetForm.placeholderDisplay == true"
                      horizontal
                      class="my-custom-class"
                      label-for="placeholder-label"
                      :label="$t('form_fields.placeholder_label')"
                    >
                      <b-input
                        id="placeholder-label"
                        v-model="widgetForm.placeholderLabel"
                        :placeholder="
                          $t('form_fields.placeholder_placeholder_text')
                        "
                      ></b-input>
                    </b-field>
                  </transition>
                  <!-- show code select -->
                  <b-field
                    horizontal
                    class="my-custom-class"
                    :label="$t('form_fields.show_code_label')"
                    label-for="show-code"
                  >
                    <b-select
                      id="show-code"
                      expanded
                      v-model="widgetForm.showCode"
                      :placeholder="$t('form_options.placeholder_show_code')"
                    >
                      <option
                        v-for="option of $t('form_options.showOptions')"
                        :value="option.value"
                        :key="option.id"
                      >
                        {{ option.text }}
                      </option>
                    </b-select>
                  </b-field>
                  <!-- visibility select -->
                  <b-field horizontal class="my-custom-class">
                    <template slot="label" label-for="visibility-select">
                      {{ $t("form_fields.visibility_label") }}
                      <b-tooltip
                        v-if="widget.id == '1'"
                        multilined
                        type="is-light"
                        size="is-large"
                        :label="$t('form_fields.tooltip_show_sgc')"
                      >
                        <font-awesome-icon
                          class="is-small"
                          :icon="['fas', 'question-circle']"
                        />
                      </b-tooltip>
                      <b-tooltip
                        v-if="widget.id == '2'"
                        multilined
                        type="is-light"
                        size="is-large"
                        :label="$t('form_fields.tooltip_show_naics')"
                      >
                        <font-awesome-icon
                          class="is-small"
                          :icon="['fas', 'question-circle']"
                        />
                      </b-tooltip>
                    </template>
                    <b-select
                      id="visibility-select"
                      expanded
                      v-model="widgetForm.selectedVisibility"
                      :placeholder="$t('form_options.placeholder_visibility')"
                    >
                      <option
                        v-for="option of $t('form_options.visibilityOptions')"
                        :value="option.value"
                        :key="option.id"
                      >
                        {{ option.text }}
                      </option>
                    </b-select>
                  </b-field>
                  <!-- input-code input -->
                  <b-field horizontal class="my-custom-class">
                    <template
                      v-if="widget.id == '2'"
                      slot="label"
                      label-for="naics-code"
                    >
                      {{ $t("form_fields.naics_code_label") }}
                      <b-tooltip
                        multilined
                        type="is-light"
                        size="is-large"
                        :label="$t('form_fields.tooltip_naics_code')"
                      >
                        <font-awesome-icon
                          class="is-small"
                          :icon="['fas', 'question-circle']"
                        />
                      </b-tooltip>
                    </template>
                    <template
                      v-if="widget.id == '1'"
                      slot="label"
                      label-for="sgc-code"
                    >
                      {{ $t("form_fields.sgc_code_label") }}
                      <b-tooltip
                        multilined
                        type="is-light"
                        size="is-large"
                        :label="$t('form_fields.tooltip_sgc_code')"
                      >
                        <font-awesome-icon
                          class="is-small"
                          :icon="['fas', 'question-circle']"
                        />
                      </b-tooltip>
                    </template>
                    <b-input
                      id="input-code"
                      v-model="widgetForm.inputCode"
                      :placeholder="$t('form_fields.placeholder_input_code')"
                    ></b-input>
                  </b-field>
                  <!-- callback function input - temporarily disabled -->
                  <!-- <b-field
                    horizontal
                    class="my-custom-class"
                    :label="$t('form_fields.callback_label')"
                    label-for="callback-function"
                  >
                    <b-input
                      expanded
                      id="callback-function"
                      v-model="widgetForm.callback"
                      :placeholder="$t('form_fields.placeholder_callback')"
                    ></b-input>
                  </b-field> -->
                  <b-button
                    @click="resetForm()"
                    class="is-light is-pulled-right"
                  >
                    {{ $t("form_fields.reset") }}
                  </b-button>
                </form>
                <div class="card-content">
                  <a
                    id="custAttLink"
                    tabindex="0"
                    @keyup.enter="onEnter"
                    @click="scrollMeTo('custom_attributes')"
                    class="docs-link is-pulled-right"
                  >
                    {{ $t("widget_details.custom_attributes_docs") }}
                  </a>
                </div>
                <!-- temporarily disabled "related data" form components
                <p class="subtitle related-data">
                  {{ $t("form_fields.related_data") }}
                  <font-awesome-icon
                    v-on:click="toggle = !toggle"
                    :icon="toggle ? 'minus-square' : 'plus-square'"
                  />
                </p>
                <fieldset></fieldset>
                <transition name="slide">
                  <form v-show="toggle" id="widgetBuilder">
                    <div class="columns">
                      <div class="column is-6">
                        <b-field grouped>
                          <b-field
                            class="data-label"
                            label-for="related-data"
                            :label="$t('form_fields.data_title')"
                          >
                            <b-checkbox
                              class="custom-checkmark"
                              v-model="widgetForm.occupationCode"
                              name="occupation-code"
                              true-value="nocs_codes"
                              false-value=""
                              >{{ $t("form_fields.occupations_label") }}
                            </b-checkbox>
                          </b-field>
                          <b-field
                            class="hidden-label"
                            :label="$t('form_fields.field_code_title')"
                          >
                            <b-input
                              id="nocs_codes"
                              :value="widgetForm.occupationCode"
                            >
                            </b-input>
                          </b-field>
                        </b-field>
                        <b-field grouped>
                          <b-field class="products-checkbox">
                            <b-checkbox
                              class="custom-checkmark"
                              v-model="widgetForm.productCode"
                              name="product-code"
                              true-value="hs_codes"
                              false-value=""
                              >{{ $t("form_fields.products_label") }}
                            </b-checkbox>
                          </b-field>
                          <b-field class="input-box-bottom">
                            <b-input
                              id="hs_codes"
                              :value="widgetForm.productCode"
                            >
                            </b-input>
                          </b-field>
                        </b-field>
                      </div>
                    </div>
                  </form>
                </transition> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ButtonCopy from "./ButtonCopy.vue";
export default {
  name: "WidgetBuilder",
  props: {
    widget: { type: Object, required: true },
    multiple: {
      type: Boolean
    },
    lang: {
      type: String
    },
    "show-label": {
      type: Boolean
    },
    showCode: {
      type: Boolean
    },
    label: {
      type: String
    },
    "placeholder-text": {
      type: String
    },
    visibility: {
      type: Boolean
    }
  }, // end props
  data: function() {
    return {
      defaultVisibility: true,
      defaultShowLabel: true,
      defaultShowCode: true,
      emptyPlaceholder: "",
      toggle: false,
      selectedData: [], // Must be an array reference
      widgetForm: {
        selectedLanguage: null,
        label: "",
        callback: "",
        showCode: null,
        showLabel: null,
        placeholderDisplay: null,
        placeholderLabel: null,
        multipleSelection: null,
        occupationCode: "",
        productCode: "",
        inputCode: "",
        selectedVisibility: null,
        provinceSelection: null
      },
      results: null
    };
  }, // end data
  components: {
    ButtonCopy
  }, // end components
  computed: {
    provinceChange: function() {
      return this.widgetForm.provinceSelection;
    },
    multipleChange: function() {
      return this.widgetForm.multipleSelection;
    },
    langChange: function() {
      if (this.widgetForm.selectedLanguage === null) {
        return this.$i18n.locale;
      } else {
        return this.widgetForm.selectedLanguage;
      }
    },
    showlabelChange: function() {
      if (this.widgetForm.showLabel === null) {
        return this.defaultShowLabel;
      } else {
        return this.widgetForm.showLabel;
      }
    },
    showcodeChange: function() {
      if (this.widgetForm.showCode === null) {
        return this.defaultShowCode;
      } else {
        return this.widgetForm.showCode;
      }
    },
    labelChange: function() {
      return this.widgetForm.label;
    },
    placeholderChange: function() {
      if (this.widgetForm.placeholderDisplay === null) {
        return this.resetPlaceholder();
      }
      if (this.widgetForm.placeholderDisplay == false) {
        return this.emptyPlaceholder;
      } else {
        return this.widgetForm.placeholderLabel;
      }
    },
    visibilityChange: function() {
      if (this.widgetForm.selectedVisibility === null) {
        return this.defaultVisibility;
      } else {
        return this.widgetForm.selectedVisibility;
      }
    },
    inputChange: function() {
      return this.widgetForm.inputCode;
    }
  }, // end computed
  methods: {
    scrollMeTo: function(refName) {
      var element = this.$parent.$refs[refName];
      var top = element.offsetTop;

      window.scrollTo(0, top);
    },
    onEnter(event) {
      if (event) {
        document.getElementById(event.target.id).click()
      }
    },
    changeCallback: function(event) {
      this.results = null;
      this.results = event;
    }, //end changeCallback
    resetForm: function() {
      this.widgetForm.selectedLanguage = null;
      this.widgetForm.label = "";
      this.widgetForm.placeholderLabel = null;
      this.widgetForm.callback = "";
      this.widgetForm.showCode = null;
      this.widgetForm.showLabel = null;
      this.widgetForm.multipleSelection = null;
      this.widgetForm.inputCode = "";
      this.widgetForm.selectedVisibility = null;
      this.widgetForm.provinceSelection = null;
      this.widgetForm.placeholderDisplay = null;
    },
    resetPlaceholder: function() {
      this.widgetForm.placeholderDisplay = null;
      this.widgetForm.placeholderLabel = null;
    }
  } // end methods
};
</script>

<style lang="scss">
.subtitle.form {
  min-width: 100%;
  margin-bottom: 24px;
}
.widget-options {
  padding: 12px;
  border-radius: 0.5rem;
  background: #f0f9ff;
  box-shadow: none;
  margin-bottom: 30px;
}
/* slide animation */
.slide-enter-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: ease-in;
  -webkit-transition-timing-function: ease-in;
  -o-transition-timing-function: ease-in;
  transition-timing-function: ease-in;
}
.slide-leave-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}
.slide-enter-to,
.slide-leave {
  max-height: 100px;
  overflow: hidden;
}
.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}

/* form css */
form.widget-form {
  .select,
  .input {
    font-size: 15px;
  }
}
.control-label {
  min-width: 8rem;
  color: #274f6e;
}
.label {
  color: #274f6e;
}
.products-checkbox {
  margin-top: 4px;
}
.related-data {
  padding-top: 24px;
}
.data-label .control-label {
  padding-top: 4px;
  padding-bottom: 4px;
}
.field.is-grouped {
  margin-bottom: 2px;
}
.html-code {
  padding-bottom: 1rem;
  font-size: 16px;
  color: #274f6e;
  font-family: monospace;
}
.has-text-left {
  font-weight: 400;
}
.form-control {
  max-width: 195px !important;
}
form.widget-form .form-control {
  width: inherit !important;
}
form.widget-form select.form-control[size],
select.form-control[multiple] {
  height: 37px;
  max-width: 195px;
}
.b-checkbox.checkbox input[type="checkbox"] + .check {
  border: 2px solid #274f6e;
}
.button-html {
  padding-top: 16px;
  padding-bottom: 12px;
}

// overwrite placehoder for b-select
// not enough contrast
.select.is-empty select {
  color: #737373;
}
.basefooter {
  clear: both !important;
}
/* live widget css */
.live-example {
  background: #fff;
  margin: 0 60px 0 0px;
  border-radius: 5px;
  padding: 40px 40px 50px 40px;
  border: 1px dashed #274f6e;
  .field-label.is-normal {
    padding: 0px;
  }
}
.vs__dropdown-menu {
  max-width: inherit !important;
  flex-grow: 0 !important;
}
.vs__dropdown-toggle {
  background: white !important;
}
.live-example-results {
  min-height: 200px;
  background: #f0f9ff;
}

.column-dark {
  background: #274f6e;
  label,
  legend {
    color: #fff;
  }
}
.widget-code {
  background: transparent;
  position: relative;
  clear: left;
  padding: 0 20px 16px 20px;
}
.triangle-left {
  border-style: solid;
  border-radius: 10% 0% 0% 10%;
  border-color: #274f6e;
}
.docs-link {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: underline;
  position: absolute;
  bottom: 16px;
  right: 32px;
}
.docs-link:hover,
.docs-link:focus {
  color: rgba(255, 255, 255, 1);
}

@media screen and (min-width: 769px), print {
  .my-custom-class .field-label {
    flex-grow: 2.5; /* overwrites previous value of 1 */
  }
}
@media screen and (max-width: 767px) {
  .triangle-left {
    display: none;
  }
}
@media screen and (max-width: 416px) {
  .triangle-left {
    display: none;
  }
  .is-pulled-right {
    font-size: 80%;
  }
  .widget-code {
    max-width: 240px;
    padding: 10px;
  }
  .column.is-7 {
    padding-left: 4px;
  }
  #nocs_codes.input {
    max-width: 96px;
    font-size: 80%;
  }
  #hs_codes.input {
    max-width: 96px;
    font-size: 80%;
  }
  .input-box-bottom {
    margin-left: 0px;
  }
  .field.data-label {
    margin-right: 4px !important;
    .label {
      font-size: 80%;
      max-width: 96px;
    }
  }
  .field.hidden-label .label {
    font-size: 80%;
    max-width: 96px;
  }
  .products-checkbox {
    margin-right: 4px !important;
  }
}
</style>
